import { ConcreteEncodable } from "./ConcreteEncodable";

import { LockLifeCycleEventImplEncoder } from "../../encoder/LockLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { LockLifeCycleEvent } from "../LockLifeCycleEvent";

export class LockLifeCycleEventImpl extends ConcreteEncodable implements LockLifeCycleEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.LockLifeCycleEventImpl";

  /*FID=1*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=2*/
  public orderIds: Array<string> | null = null;
  /*FID=3*/
  public lockType: CubiqTS.LockType;
  /*FID=4*/
  public lockUserId: CubiqTS.Long | null = null;
  /*FID=5*/
  public lockUser: string;
  /*FID=6*/
  public clOrderIds: Array<string> | null = null;
  /*FID=7*/
  public id: string;
  /*FID=8*/
  public orderDatas: Array<CubiqTS.OrderData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = LockLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(LockLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "LockLifeCycleEventImpl[" +
      "eventTypeId=" +
      this.eventTypeId +
      "orderIds=" +
      this.orderIds +
      "lockType=" +
      this.lockType +
      "lockUserId=" +
      this.lockUserId +
      "lockUser=" +
      this.lockUser +
      "clOrderIds=" +
      this.clOrderIds +
      "id=" +
      this.id +
      "orderDatas=" +
      this.orderDatas +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
